import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  API_ENDPOINT,
  primaryPaletteColor,
} from '../configurations/global.config';
import { AuthContext } from './user-context/user-context';
import axios from 'axios';
import { useSnackBar } from './snackbar';
import { OrgSettingsContext } from './org-settings-context';

type Props = {
  children?: ReactNode;
};

export interface ForcedOrganisation {
  organisation_id: string;
  brand: string;
  custom_primary_color: string;
  logoUrl: string;
  navbar_logo: string | null;
}

type DomainForcedOrganisationContextProps = {
  forcedOrganisation: ForcedOrganisation | null;
  setForcedOrganisation: (o: ForcedOrganisation | null) => void;
  isLoading: boolean;
};

const initialValue: DomainForcedOrganisationContextProps = {
  forcedOrganisation: null,
  setForcedOrganisation: () => {/* to be implemented */},
  isLoading: false
};

const CACHE_KEY = 'pt-domain-forced-orgs';
const CACHE_TTL = 600000; // 10 minutes in ms

const DomainForcedOrganisationContext =
  createContext<DomainForcedOrganisationContextProps>(initialValue);

const DomainForcedOrganisationProvider = ({ children }: Props) => {
  const [forcedOrg, setForcedOrg] = useState<ForcedOrganisation | null>(null);
  const [isLoading, setIsLoading] = useState(true)
  const {color, setColor} = useContext(OrgSettingsContext)
  console.log("Rendered DomainForcedOrganisationProvider")

  useEffect(()=>{
    console.log(forcedOrg)
    if (forcedOrg && forcedOrg.custom_primary_color != color)
      setColor(forcedOrg.custom_primary_color)
  })

  useEffect(() => {
    const fetchOrgFromDomain = async () => {
      const subdomain = window.location.host.split('.')[0];
      
      // Load cache
      const cached = localStorage.getItem(CACHE_KEY);
      const cache: Record<
        string,
        { data: ForcedOrganisation; timestamp: number }
      > = cached ? JSON.parse(cached) : {};

      // Check if cached and still valid
      const cachedEntry = cache[subdomain];
      const now = Date.now();

      if (cachedEntry && now - cachedEntry.timestamp < CACHE_TTL) {
        // Use cached data
        setForcedOrg(cachedEntry.data);
        setIsLoading(false)
        return;
      }

      // Otherwise fetch fresh
      try {
        setIsLoading(true)
        const response = await axios.get<ForcedOrganisation>(
          `${API_ENDPOINT}/v1/organisations/?subdomain=${subdomain}`,
        );

        const orgData = response.data;
        setForcedOrg(orgData);

        // Update cache
        cache[subdomain] = { data: orgData, timestamp: now };
        localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
      } catch (e) {
        console.error('Failed to fetch org from subdomain:', e);
      } finally {
        setIsLoading(false)
      }
    };

    fetchOrgFromDomain();
  }, []);

  return (
    <DomainForcedOrganisationContext.Provider
      value={{ forcedOrganisation: forcedOrg, setForcedOrganisation: setForcedOrg, isLoading }}
    >
      {children}
    </DomainForcedOrganisationContext.Provider>
  );
};

export {
  DomainForcedOrganisationContext,
  DomainForcedOrganisationProvider,
};
